import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Team.css";
import { Link } from "react-router-dom";
import { BASE_URL, STATIC_BASE_URL } from "../../config/baseUrl";

export default function Team() {
  const [teamMembers, setTeamMembers] = useState([]);
  const fallbackImage = `${process.env.PUBLIC_URL}/assets/img/team/team-1.jpg`;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    const fetchTeam = async () => {
      try {
        const res = await fetch(`${BASE_URL}/Mentor`);

        if (!res.ok) throw new Error(`Network response was not ok: ${res.status}`);
        const data = await res.json();
        setTeamMembers(data);
      } catch (err) {
        console.error("Error fetching team:", err);
      }
    };

    fetchTeam();
  }, []);

  // Helper to build image URL
  const getImageUrl = (profileImageUrl) => {
    if (!profileImageUrl) return fallbackImage;

    // If absolute URL, return as is
    if (profileImageUrl.startsWith("https")) return profileImageUrl;

    return `${STATIC_BASE_URL}/${profileImageUrl.replace(/\\/g, "/")}`;

  };

  return (
    <section id="team" className="team section section-bg dark-background">
      <div className="container section-title" data-aos="fade-up">
        <h2>Our Coaches</h2>
        <p>Meet the people who make everything possible.</p>
      </div>

      <div className="container">
        <div className="row gy-4 mt-4">
          {teamMembers.map((member, index) => (
            <div
              className="col-lg-3 col-md-6 col-sm-12 d-flex align-items-stretch"
              data-aos="fade-up"
              data-aos-delay={100 * (index + 1)}
              key={member.mentorId}
            >
              <div className="team-member card-shadow">
                <div className="member-img">
                  <img
                    src={getImageUrl(member.profileImageUrl)}
                    className="img-fluid mentor-img"
                    alt={member.mentorName || "Mentor"}
                    onError={(e) => {
                      e.target.src = fallbackImage;
                    }}
                  />
                </div>
                <div className="member-info">
                  <Link to={`/team/${member.mentorId}`}>
                    <h4>{member.mentorName}</h4>
                  </Link>
                  <span>{member.specialization || member.role}</span>
                  <Link
                    to={`/team/${member.mentorId}`}
                    className="btn btn-get-started mt-3"
                  >
                    View Profile
                  </Link>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
